function WriteArea(props: any) {
  let myProps = {
    row_data: {},
    set_row_data: (inData: any) => { },
    ...props
  };
  let row_data = myProps.row_data;

  const on_change_input = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;
    let change_row_data = { ...myProps.row_data };
    change_row_data[name] = value;
    myProps.set_row_data(change_row_data);
  };

  return (
    <div>
      <div>
        <select
          value={row_data.a_word_type}
          name="a_word_type"
          onChange={on_change_input}
          className="w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 bg-white cursor-pointer hover:border-gray-400"
        >
          <option value="word">단어</option>
          <option value="stc">문장</option>
        </select>
      </div>
      <div className="mt-2">
        <input
          type="text"
          name="a_title"
          value={row_data.a_title}
          onChange={on_change_input}
          placeholder="제목"
          autoComplete="off"
          className="w-full px-4 py-3 text-lg border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
        />
      </div>
    </div>
  );
};
export default WriteArea;